const ACCORDION_MS = 280;

const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const panelInner = (panel) => panel.querySelector('.daedae-contact__accordion-inner');

const clearAnim = (panel) => {
  if (panel._daedaeOnEnd) {
    panel.removeEventListener('transitionend', panel._daedaeOnEnd);
    panel._daedaeOnEnd = null;
  }
};

const setPanel = (item, open) => {
  const button = item.querySelector('.daedae-contact__accordion-trigger');
  const panel = item.querySelector('.daedae-contact__accordion-panel');
  if (!button || !panel) return;

  const inner = panelInner(panel);
  button.setAttribute('aria-expanded', open ? 'true' : 'false');
  panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  item.classList.toggle('is-open', open);

  if (open) {
    panel.removeAttribute('inert');
  }

  if (reducedMotion() || !inner) {
    panel.style.height = open ? 'auto' : '0px';
    panel.style.opacity = open ? '1' : '0';
    if (!open) panel.setAttribute('inert', '');
    return;
  }

  clearAnim(panel);

  const start = panel.getBoundingClientRect().height;
  if (open) panel.style.height = `${start}px`;
  else panel.style.height = `${Math.max(start, inner.scrollHeight)}px`;

  panel.style.opacity = open ? '0' : getComputedStyle(panel).opacity || '1';

  requestAnimationFrame(() => {
    const end = open ? inner.scrollHeight : 0;
    panel.style.height = `${end}px`;
    panel.style.opacity = open ? '1' : '0';
  });

  panel._daedaeOnEnd = (event) => {
    if (event.target !== panel || event.propertyName !== 'height') return;
    clearAnim(panel);
    if (open) panel.style.height = 'auto';
    else panel.setAttribute('inert', '');
  };
  panel.addEventListener('transitionend', panel._daedaeOnEnd);
};

const closeOthers = (root, current) => {
  root.querySelectorAll('[data-daedae-accordion-item].is-open').forEach((item) => {
    if (item !== current) setPanel(item, false);
  });
};

const syncName = (root) => {
  const name = root.querySelector('[data-contact-name]');
  if (!name) return;
  const first = root.querySelector('[data-contact-first]')?.value.trim() || '';
  const last = root.querySelector('[data-contact-last]')?.value.trim() || '';
  name.value = [first, last].filter(Boolean).join(' ');
};

const initAccordions = (root) => {
  root.querySelectorAll('[data-daedae-accordion-item]').forEach((item) => {
    const button = item.querySelector('.daedae-contact__accordion-trigger');
    const panel = item.querySelector('.daedae-contact__accordion-panel');
    if (!button || !panel || button.dataset.daedaeBound === 'true') return;
    button.dataset.daedaeBound = 'true';

    if (!item.classList.contains('is-open')) {
      panel.style.height = '0px';
      panel.style.opacity = '0';
      panel.setAttribute('inert', '');
    }

    button.addEventListener('click', () => {
      const willOpen = !item.classList.contains('is-open');
      closeOthers(root, item);
      setPanel(item, willOpen);
    });
  });
};

const initForm = (root) => {
  const form = root.querySelector('.daedae-contact__form');
  if (!form || form.dataset.daedaeBound === 'true') return;
  form.dataset.daedaeBound = 'true';

  const sync = () => syncName(root);
  root.querySelector('[data-contact-first]')?.addEventListener('input', sync);
  root.querySelector('[data-contact-last]')?.addEventListener('input', sync);
  form.addEventListener('submit', sync);

  const status = root.querySelector('.daedae-contact__status');
  if (status) status.focus();
};

const initContact = (root) => {
  if (!root) return;
  initAccordions(root);
  initForm(root);
};

const initAll = () => {
  document.querySelectorAll('[data-daedae-contact]').forEach(initContact);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll, { once: true });
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (event) => {
  initContact(event.target.querySelector('[data-daedae-contact]'));
});
